module.exports = __webpack_public_path__ + "img/SKMJ_limit7.5245890b.jpg";